/** Shared integer ticks for the SVG and HTML versions of the records chart. */
export function recordIntegerAxis(min: number, max: number) {
  const roughStep = Math.max(1, (max - min) / 2);
  const magnitude = 10 ** Math.floor(Math.log10(roughStep));
  const step = Math.max(1, Math.ceil(roughStep / magnitude) * magnitude);
  const start = Math.max(0, Math.floor(min / step) * step);
  const end = Math.max(start + step, Math.ceil(max / step) * step);
  const ticks = Array.from(
    {length: Math.round((end - start) / step) + 1},
    (_, i) => start + i * step,
  );
  return {min: start, max: end, ticks};
}
